module.exports = __webpack_public_path__ + "static/PPNeueMontreal-Regular-7aa28cf1714232b3f8236a5369a9d432.ttf";